import React from 'react';
import { ColumnType, FilterDropdownProps } from 'antd/es/table/interface';
import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Row, Col } from '@idaho-aeyc/ui-kit';
import { useTranslation } from '@packages/utils';

const SearchFilterDropdown = ({
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
  placeholder,
  searchText,
  resetText,
  inputType,
}: FilterDropdownProps & {
  placeholder: string;
  searchText: string;
  resetText: string;
  inputType: string;
}) => (
  <Row gutter={[8, 8]} className="p-2" onKeyDown={e => e.stopPropagation()}>
    <Col span={24}>
      <Input
        autoFocus
        placeholder={placeholder}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        type={inputType}
        onPressEnter={() => confirm()}
      />
    </Col>
    <Col span={24}>
      <Row gutter={[8, 8]}>
        <Col>
          <Button
            color="primary"
            onClick={() => {
              clearFilters?.();
              confirm();
            }}
            disabled={selectedKeys.length === 0}
          >
            {resetText}
          </Button>
        </Col>
        <Col>
          <Button type="primary" onClick={() => confirm()} color="primary">
            {searchText}
          </Button>
        </Col>
      </Row>
    </Col>
  </Row>
);

const useGetTableColumnData = () => {
  const { t } = useTranslation({
    keyPrefix: 'descriptions.generic-components.table.columns-search',
  });

  const getTableColumnSearchProps = <T,>(
    inputType?: string,
  ): ColumnType<T> => ({
    filterDropdown: props => (
      <SearchFilterDropdown
        {...props}
        placeholder={t('SEARCH_HERE_LABEL')}
        searchText={t('SEARCH_LABEL')}
        resetText={t('RESET_BTN')}
        inputType={inputType || 'text'}
      />
    ),
    filterIcon: () => <SearchOutlined size={14} />,
  });

  return { getTableColumnSearchProps };
};

export default useGetTableColumnData;
